module.exports = __webpack_public_path__ + "img/img013.3257f671.png";